module.exports = __webpack_public_path__ + "static/aurimas-adomavicius-cb04fe68cf528b4b13a3dacec9eeccf0.jpg";